define.alias("ember-math-helpers/helpers/tan", "settings/helpers/tan");